<template>
  <svg xmlns="http://www.w3.org/2000/svg" :height="size + 'px'" viewBox="0 0 24 24" :width="size + 'px'" fill="currentColor">
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
  </svg>
</template>

<script>
import IconBase from "@/mixins/Icon/IconBase";

export default {
  name: "IconChevronLeft",
  mixins: [ IconBase ],
  props: { ...IconBase.props,
    size: {
      default: "22"
    }
  }
}
</script>